import { Pages } from './pages';

export class Survey {
  isCompleted: boolean;
  ID: number;
  InterventionsCount: number;
  Pages: Pages[] = []; 
}
